/**
 * Phiếu kết chuyển tài khoản
 * pntoan 20.5.2024
 */
export default {
  Title: 'Phiếu kết chuyển tài khoản',
  LedgerTitle: 'Kết chuyển tài khoản',
  Detail: {
    Description: "Diễn giải",
    DocumentInclude: 'Kèm theo',
    PostedDate: 'Ngày HT',
    PostedDateTitle: 'Ngày hạch toán',
    RefDate: 'Ngày CT',
    RefDateTitle: 'Ngày chứng từ',
    RefNo: 'Số CT',
    RefNoTitle: 'Số chứng từ',
    DetailListNo: 'Số bảng kê',
  }
};
